import { ModalFooter } from 'ui-components/components/modal/modal-footer';

import style from './cost-review-modal-footer.module.css';
import { RetrySection } from '../../../financial-services-ui/surcharge/retry-section';
import { CostReviewLineItemSummary } from '../../cost-review-line-item/cost-review-line-item-summary';

/**
 * @typedef TransactionPreviewProps
 * @property {number} creditCardProcessingFee
 * @property {number} creditCardProcessingFeePercentage
 * @property {boolean} surchargeLoading
 * @property {string} previewError
 * @property {() => void} triggerPreviewRetry
 * @property {boolean} hasSurchargeCheckedAtLeastOnce
 */

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {boolean} props.isSummaryReadonly
 * @param {(newShipDate: string) => void} props.onShipDateChanged
 * @param {string} props.shipDate
 * @param {import('../../../hooks/cost-review/use-combined-cost-info').CombinedCostInfo} props.combinedCostInfo
 * @param {TransactionPreviewProps} props.transactionPreviewProps
 * @param {string} props.userDateFormat
 * @param {string[]} props.fulfillmentPlanIds
 * @returns {React.JSX.Element}
 */
export const CostReviewModalFooter = ({
  children,
  transactionPreviewProps,
  isSummaryReadonly,
  onShipDateChanged,
  shipDate,
  combinedCostInfo,
  userDateFormat,
  fulfillmentPlanIds = [],
}) => {
  const {
    previewError,
    surchargeLoading,
    hasSurchargeCheckedAtLeastOnce,
    triggerPreviewRetry,
    creditCardProcessingFee,
    creditCardProcessingFeePercentage,
  } = transactionPreviewProps;
  return (
    <ModalFooter className={style['cost-review-modal-footer']}>
      {!!previewError && <RetrySection isLoading={surchargeLoading} triggerRetry={triggerPreviewRetry} />}
      {!previewError && hasSurchargeCheckedAtLeastOnce ? (
        <CostReviewLineItemSummary
          combinedCostInfo={combinedCostInfo}
          creditCardProcessingFee={creditCardProcessingFee}
          creditCardProcessingFeePercentage={creditCardProcessingFeePercentage}
          fulfillmentPlanIds={fulfillmentPlanIds}
          onShipDateChanged={onShipDateChanged}
          readOnly={isSummaryReadonly}
          shipDate={shipDate}
          userDateFormat={userDateFormat}
        />
      ) : null}
      <div className={style['cost-review-modal-footer-buttons-container']}>{children}</div>
    </ModalFooter>
  );
};
